import React from 'react';

import type { GridCellParams } from '@mui/x-data-grid-premium';
import { useGridApiContext } from '@mui/x-data-grid-premium';

import { WorkflowListGroupLabelCell } from './WorkflowListGroupLabelCell';
import { WorkflowAssigneesChooser } from '../../assignees';
import type { WorkflowListGridRow, WorkflowListRow } from '../WorkflowsList';
import { getIsWorkflowListGroupRow, getIsWorkflowListWorkflowRow } from '../WorkflowsList';

export function WorkflowAssigneesCell({
  field,
  row,
}: GridCellParams<WorkflowListGridRow, WorkflowListRow['permissions']>) {
  const apiRef = useGridApiContext();
  if (getIsWorkflowListGroupRow(row)) {
    return (
      <WorkflowListGroupLabelCell count={row.workflowCount} field={field} label={row.groupLabel} />
    );
  }
  if (!getIsWorkflowListWorkflowRow(row)) return null;

  return <WorkflowAssigneesChooser apiRef={apiRef} workflow={row} />;
}
